import { type PropsWithChildren } from 'react';
import { Button, type ButtonProps } from '@avanta/shared/components/ui/Button';
import { useUnreadConversations } from '@avanta/shared/stores/chat/conversations';
import { cn } from '@avanta/shared/utils/cn';

export interface NotificationButtonProps extends ButtonProps {
  notificationUserId?: string;
}

export const NotificationButton = ({
  notificationUserId,
  size,
  children,
  ...props
}: PropsWithChildren<NotificationButtonProps>): React.ReactElement => {
  const unreadCounts = useUnreadConversations();
  const isNotification = unreadCounts.some(
    conversation => conversation.userId === notificationUserId
  );
  return (
    <Button {...props} size={size}>
      {children}
      {isNotification && (
        <div
          className={cn(
            'size-2.5 rounded-full bg-red-500 absolute right-2 outline-2 shadow-box-lg outline-white',
            size === 'lg' ? '-top-1.5' : '-top-1'
          )}
        />
      )}
    </Button>
  );
};
